"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _clsx2 = _interopRequireDefault(require("clsx"));

var _loader = _interopRequireDefault(require("./loader.css"));

var Loader = function Loader(_ref) {
  var _clsx;

  var className = _ref.className,
      transparent = _ref.transparent,
      fullscreen = _ref.fullscreen;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx2["default"])((_clsx = {}, _clsx[_loader["default"].overlay] = !transparent, _clsx[_loader["default"].fullscreen] = fullscreen, _clsx), _loader["default"].loader, _loader["default"].loading, className)
  });
};

Loader.defaultProps = {
  fullscreen: true
};
var _default = Loader;
exports["default"] = _default;